"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'dblogs.col.model': 'Model',
    'dblogs.col.operation': 'Operation',
    'dblogs.col.recordId': 'Record ID',
    'dblogs.col.date': 'Date',
    'dblogs.col.payload': 'Payload',
    'dblogs.col.result': 'Result',
};
